// sagas.js
import { takeEvery, call, put } from 'redux-saga/effects';
import { deleteCategory, getAllCategories, getCategory, updateCategory } from '../../helpers/backend_helper';
import { fetchCategoriesFailure, fetchCategoriesSuccess, updateCategoryFailure, updateCategorySuccess } from './actions';
import { deleteCategoryFailure, deleteCategorySuccess, fetchCategoryFailure, fetchCategorySuccess } from '../actions';
import { DELETE_CATEGORIES_REQUEST, FETCH_CATEGORIES_REQUEST, FETCH_CATEGORY_REQUEST, UPDATE_CATEGORIES_REQUEST } from './actionTypes';
import { reduxSerializedError } from '../../utils/utils';

function* fetchCategoriesSaga() {
  try {
    const response = yield call(getAllCategories);

    yield put(fetchCategoriesSuccess(response.data));
  } catch (error) {
    yield put(fetchCategoriesFailure(reduxSerializedError(error)));
  }
}

function* fetchCategorySaga({ payload }) {
  try {
    const response = yield call(getCategory, payload);
    yield put(fetchCategorySuccess(response));
  } catch (error) {
    yield put(fetchCategoryFailure(reduxSerializedError(error)));
  }
}

function* deleteCategoriesSaga({ payload }) {
  try {
    yield call(deleteCategory, payload);
    yield put(deleteCategorySuccess(payload));
    yield call(fetchCategoriesSaga);
  } catch (error) {
    yield put(deleteCategoryFailure(reduxSerializedError(error)));
  }
}

function* updateCategorySaga({ payload }) {
  const { project } = payload;
  try {
    yield call(updateCategory, project);
    yield put(updateCategorySuccess());
    yield call(fetchCategoriesSaga); 
  } catch (error) {
    yield put(updateCategoryFailure(reduxSerializedError(error)));
  }
}

export default function* rootSaga() {
  yield takeEvery(FETCH_CATEGORIES_REQUEST, fetchCategoriesSaga);
  yield takeEvery(FETCH_CATEGORY_REQUEST, fetchCategorySaga);
  yield takeEvery(UPDATE_CATEGORIES_REQUEST, updateCategorySaga);
  yield takeEvery(DELETE_CATEGORIES_REQUEST, deleteCategoriesSaga);
}
